document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    initVariantChangeListener();
  }, 2000);
});

function initVariantChangeListener() {
  const variantInputs = document.querySelectorAll(
    "[bss-b2b-main-product-form] .maxus-productdetail__options input"
  );
  if (variantInputs.length) {
    variantInputs.forEach((item) => {
      item.addEventListener("click", (e) => {
        const productForm = document.querySelector(
          "[bss-b2b-main-product-form]"
        );
        if (productForm) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { event: e, productForm }
          );
        }
      });
    });
  }
}
